import { Box } from "@mui/material";

const BrandLogo = ({ src, alt, borderColor = "rgba(0,0,0,0.04)" }) => {
  return (
    <Box
      sx={(theme) => ({
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        px: "16px",
        py: "4px",
        borderRadius: "22.34px",
        border: `1px solid ${borderColor}`,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        flexShrink: 0,
        whiteSpace: "nowrap",
        justifyContent: "center",
        bgcolor: "white",
      })}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          aspectRatio: "2.81",
          height: "26.59px",
          width: "auto",
          objectFit: "contain",
          display: "block",
          mixBlendMode: "multiply",
        }}
      />
    </Box>
  );
};

export default BrandLogo;
